import { crop_the_image } from "packs/custom_js/imageid_crop.js"
import { display_error } from "packs/custom_js/alerts.js"
import { display_notice } from "packs/custom_js/alerts.js"
Window.imove_global = {
	crop_the_image: crop_the_image,
  display_error: display_error,
  display_notice: display_notice
}